import { Gutter } from 'antd/es/grid/row';
import { Breakpoint } from 'antd/es/_util/responsiveObserve';

export const grid: { [key: string]: number | Partial<Record<Breakpoint, number>> | [Gutter, Gutter] | undefined } = {
  mainRowGutter: [40, 40],
  formInputRowGutter: [{ xs: 8, sm: 16, md: 24, lg: 32 }, 20],
  formInputRowGroupGutter: [{ xs: 8, sm: 16, md: 24, lg: 32 }, 0],
};
